import { Controller } from '@hotwired/stimulus';

export default class NavbarController extends Controller {
  static targets = ['menu'];

  disconnect() {
    this.hideBackdrop();
  }

  showBackdrop() {
    this.backdrop = document.createElement('div');
    this.backdrop.classList.add('navbar-backdrop');
    this.backdrop.addEventListener('click', this.closeMenu.bind(this));
    document.body.appendChild(this.backdrop);
    document.body.classList.add('overflow-hidden');
  }

  hideBackdrop() {
    if (this.backdrop) {
      this.backdrop.remove();
      this.backdrop = null;
    }
    document.body.classList.remove('overflow-hidden');
  }

  closeMenu() {
    bootstrap.Collapse.getInstance(this.menuTarget)?.hide();
  }
}
